<template>
    <default-layout v-if="!appIsInitialized" />
    <router-view v-else />
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {ElMessageBox} from "element-plus";
import {rootContext} from "@/store";
import type {MessageOptions} from "element-plus";
import DefaultLayout from "@/layout/DefaultLayout.vue";

export default defineComponent({
    name: "App",
    components: {
        DefaultLayout
    },
    mounted(): void {
        window.addEventListener("online", () => {
            rootContext.mutations.setIsOffline(false);
            rootContext.actions.runCommands();
        });

        window.addEventListener("offline", () => {
            rootContext.mutations.setIsOffline(true);
        });

        this.$events.on("message", (options: MessageOptions | undefined) => {
            if (!options) return;

            this.$message(options);
        });

        this.$events.on("service-worker-updated", () => {
            ElMessageBox.confirm(
                "A refresh is required in order to update.",
                "New content available", {
                    confirmButtonText: "Refresh",
                    type: "info",
                    center: true,
                    showCancelButton: false,
                    closeOnClickModal: false,
                }
            )
                .then(() => {
                    navigator.serviceWorker.getRegistrations()
                        .then(registrations => {
                            for (const registration of registrations) {
                                registration.unregister();
                            }

                            window.location.reload();
                        });
                })
                .catch(() => console.warn("Update canceled."));
        });
    },
    computed: {
        appIsInitialized(): boolean {
            return rootContext.getters.isInitialized;
        }
    }
});
</script>

<style lang="scss">
@import "scss/app";
</style>
